import React from 'react';
import Content from 'src/components/Content';
import { Grid } from '@material-ui/core';
import ProfileDetails from './ProfileDetails';
import GeneralSettings from './GeneralSettings';

function Settings() {
  return (
    <Content title="Settings" maxWidth="lg">
      <Grid
        container
        spacing={3}
      >
        <Grid
          item
          lg={4}
          md={6}
          xl={3}
          xs={12}
        >
          <ProfileDetails />
        </Grid>
        <Grid
          item
          lg={8}
          md={6}
          xl={9}
          xs={12}
        >
          <GeneralSettings />
        </Grid>
        {/* <Grid */}
        {/*  item */}
        {/*  xs={12} */}
        {/* > */}
        {/*  <Card title="Edit signature" p={0}> */}
        {/*    <SignatureBlockEditor /> */}
        {/*  </Card> */}
        {/* </Grid> */}
      </Grid>
    </Content>
  );
}

export default Settings;
